// extracted by mini-css-extract-plugin
module.exports = {"badge":"Badge_badge__aAKcs","red":"Badge_red__1-MD-","blue":"Badge_blue___5qEp"};